import React from "react";

interface EventProps {
  event: {
    id: number;
    title: string;
    time: string;
    description: string;
    eventType?: string;
  };
  onClick?: () => void;
}

const getEventColor = (eventType?: string) => {
  switch (eventType?.toLowerCase()) {
    case "walkthrough":
      return "bg-green-100 border-green-500";
    case "inspection":
      return "bg-yellow-100 border-yellow-500";
    case "client meeting":
      return "bg-blue-100 border-blue-500";
    case "training":
      return "bg-purple-100 border-purple-500";
    case "inventory":
      return "bg-gray-100 border-gray-500";
    case "prospect meeting":
      return "bg-pink-100 border-pink-500";
    case "team onboarding":
      return "bg-indigo-100 border-indigo-500";
    default:
      return "bg-blue-100 border-blue-500";
  }
};

const Event: React.FC<EventProps> = ({ event, onClick }) => {
  const colorClasses = getEventColor(event.eventType);

  return (
    <div
      className={`${colorClasses} mb-1 cursor-pointer rounded border-l-4 p-1 text-xs hover:opacity-80`}
      onClick={onClick}
    >
      <div className="font-medium">{event.title}</div>
      <div className="text-gray-600">{event.time}</div>
    </div>
  );
};

export default Event;
